import React from 'react'

export const PageNotFound = () => (
  <div>ViewNotFound</div>
)
